import React, { Component } from 'react';
import FontIcon from 'material-ui/FontIcon';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import Collapse from './Collapse';
import CarDetails from './CarDetails';
import InfoNA from './InfoNA';

import { m } from '../../utils';
import './reportDetails.css';

const timeHeader = (startTime, endTime) => {
  if (m(startTime).isSame(endTime, 'day')) {
    return `${m(startTime).format('ddd D MMM, hA')} - ${m(endTime).format(
      'hA'
    )}`;
  }
  return `${m(startTime).format('ddd D MMM, hA')} - ${m(endTime).format(
    'ddd D MMM, hA'
  )}`;
};

class ShiftDetails extends Component {
  constructor(props) {
    super(props);
    this.state = { isRefreshing: false };
  }

  handleRefresh = () => {
    this.setState({ isRefreshing: true }, () => window.location.reload());
    setTimeout(() => this.setState({ isRefreshing: false }), 1000);
  };

  render() {
    const {
      booking: {
        id,
        car,
        startTime,
        endTime,
        isIn30Mins,
        vehicleClass,
        address,
        city
      },
      index,
      openDialog
    } = this.props;
    const duration = m(endTime).diff(m(startTime), 'hours');
    // const isBookingNotOver = m(endTime).isAfter(m().add(30, 'minutes'));
    return car ? (
      <Collapse
        initiallyExpanded={index === 0}
        header={
          <div className="details_header">
            <h6>{timeHeader(startTime, endTime)}</h6>
            <h6>
              Autzu {vehicleClass.toUpperCase()} - {duration} hours
            </h6>
          </div>
        }>
        <div className="details">
          <div className="details_shift">
            {isIn30Mins ? <CarDetails car={car} /> : null}
            <p>
              <FontIcon
                className="fa fa-map-marker"
                style={{ fontSize: 16 }}
              />{' '}
              <a
                href="https://goo.gl/maps/8EvwF3dF1Wt"
                target="_blank"
                rel="noopener noreferrer"
                className="maps-link">
                {address}, {city}
              </a>
            </p>
          </div>

          {isIn30Mins ? null : (
            <div className="details_car">
              <InfoNA
                openDialog={openDialog}
                startTime={startTime}
                bookingId={id}
              />
            </div>
          )}
        </div>
        <button className="blank-btn" onClick={this.handleRefresh}>
          <FontAwesomeIcon
            icon={['fal', 'sync']}
            spin={this.state.isRefreshing}
          />
        </button>
      </Collapse>
    ) : null;
  }
}

export default ShiftDetails;



// WEBPACK FOOTER //
// ./src/components/Dashboard/ShiftDetails.js